import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { scaleFadeIn400ms } from 'src/app/shared/animations/scale-fade-in.animation';
import { NavigationItem } from '../../../interfaces/navigation-item.interface';
import { LayoutService } from 'src/app/core/services/layout.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AccessService } from 'src/app/core/services/access.service';
import { SplashScreenService } from 'src/app/core/services/splash-screen.service';
import { environment as env } from '../../../../../environments/environment';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { WebSocktesService } from 'src/app/shared/services/webSockets.service';
import { NotificationsService } from 'src/app/core/notifications/services/notifications.service';
import { MatBadgeModule } from '@angular/material/badge';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SidenavItemComponent } from './components/sidenav-item/sidenav-item.component';
import { NotificationsPopUpComponent } from 'src/app/core/notifications/components/notifications-pop-up/notifications-pop-up.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mg-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: true,
  imports: [MatBadgeModule, IconComponent, MatTooltipModule, SidenavItemComponent, MatMenuModule, NotificationsPopUpComponent, CommonModule],
  animations: [scaleFadeIn400ms],
})
export class SidenavComponent implements OnChanges {
  @Input() collapsed: boolean | null;
  @Input() isDesktop: boolean | null;
  @ViewChild('menuTriggerNotifications') menuTriggerNotifications: MatMenuTrigger;
  @Output() clickItem = new EventEmitter<boolean>();
  items: NavigationItem[] = this._navigationService.items;
  counterNotifications: number = 0;
  env = env;

  constructor(
    private readonly _navigationService: NavigationService,
    private readonly _authService: AuthService,
    private readonly _accessService: AccessService,
    private readonly _dialog: MatDialog,
    private readonly _layoutService: LayoutService,
    private readonly _splashScreenService: SplashScreenService,
    private readonly _webSocketsService: WebSocktesService,
    private readonly _notificationsService: NotificationsService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isDesktop"]["currentValue"]) {
      this._notificationsService.countNotifications$.subscribe(x => {
        this.badgeCounterNotifications(x);
      })
    }
  }

  toggleCollapse() {
    this.collapsed
      ? this._layoutService.expandSidenav()
      : this._layoutService.collapseSidenav();
  }

  logout() {
    this._webSocketsService.stopAllConections().then(() => {
      this._splashScreenService.show();
      this._authService.logout().subscribe({
        next: (resp) => {
          if (resp) {
            this._accessService.removeAccess().subscribe(() => {
              this._dialog.closeAll();
              globalThis.location.href = 'auth/login';
            });
          }
        },
        error: e => {
          console.warn(e.error.message)
          this._accessService.removeAccess().subscribe(()=>{
                this._dialog.closeAll();
                globalThis.location.reload();
              });
                this._splashScreenService.hide();

        }
      });
    })
  }

  badgeCounterNotifications(counter: number) {
    setTimeout(() => {
      this.counterNotifications = counter;
    }, 0)
  }

  clickItemAction(e: boolean) {
    this.clickItem.emit(e);
  }
}
